import { type SearchIndex } from 'algoliasearch';
import { AlgoliaGroceryIndex, AlgoliaRecipeIndex } from '../env';
import { algoliaClient as AlgoliaSearchClient } from '../lib/algolia-client';

export const AlgoliaSearchIndexes: { [key: string]: SearchIndex } = {};
AlgoliaSearchIndexes[AlgoliaRecipeIndex] =
  AlgoliaSearchClient.initIndex(AlgoliaRecipeIndex);
AlgoliaSearchIndexes[AlgoliaGroceryIndex] =
  AlgoliaSearchClient.initIndex(AlgoliaGroceryIndex);
